module.exports = __webpack_public_path__ + "static/img/30015 (2).ef87f13.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30015 (2).webp
// module id = 7Kul
// module chunks = 14